<div class="email-support-modal" [class.expanded]="isExpanded">
  <div class="email-banner">
    <h2 class="banner-title">{{ subject }}</h2>
    <div class="banner-actions">
      <button
        type="button"
        class="banner-btn"
        title="Minimize"
        (click)="closeDialog()"
        aria-label="Minimize"
      >
        <svg class="banner-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            d="M6 12h12"
          />
        </svg>
      </button>
      <button
        type="button"
        class="banner-btn"
        [title]="isExpanded ? 'Restore' : 'Expand'"
        (click)="toggleExpand()"
        [attr.aria-label]="isExpanded ? 'Restore' : 'Expand'"
      >
        <svg
          *ngIf="!isExpanded"
          class="banner-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M14 4h6v6M10 20H4v-6M20 4l-6.5 6.5M4 20l6.5-6.5"
          />
        </svg>
        <svg
          *ngIf="isExpanded"
          class="banner-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10 14H4v6M14 10h6V4M4 20l6.5-6.5M20 4l-6.5 6.5"
          />
        </svg>
      </button>
      <button
        type="button"
        class="banner-btn"
        title="Close"
        (click)="closeDialog()"
        aria-label="Close"
      >
        <svg class="banner-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            d="M6 6l12 12M18 6L6 18"
          />
        </svg>
      </button>
    </div>
  </div>

  <div class="email-fields">
    <div class="field-row">
      <input class="field-input" type="text" [value]="to" readonly />
    </div>
    <div class="field-row">
      <input class="field-input" type="text" [(ngModel)]="subject" />
    </div>
  </div>

  <div class="email-body-wrapper">
    <div
      #bodyEditor
      class="email-body"
      contenteditable="true"
      role="textbox"
      aria-multiline="true"
    ></div>
  </div>

  <div class="email-toolbar-area">
    <div class="format-bar-row" *ngIf="showFormatToolbar">
      <div class="format-toolbar">
        <div class="font-select-wrap">
          <select
            class="font-select"
            [ngModel]="selectedFont"
            (ngModelChange)="onFontChange($event)"
            (mousedown)="preventBlur($event)"
          >
            <option *ngFor="let font of fonts" [value]="font">{{ font }}</option>
          </select>
          <span class="caret-icon" aria-hidden="true"></span>
        </div>

        <div class="menu-wrap" (click)="keepMenuOpen($event)">
          <button
            type="button"
            class="tool-btn has-caret"
            title="Font size"
            (mousedown)="preventBlur($event)"
            (click)="toggleMenu('fontSize', $event)"
          >
            <span class="tt-icon">TT</span>
            <span class="caret-icon"></span>
          </button>
          <div class="menu-panel" *ngIf="openMenu === 'fontSize'">
            <button
              type="button"
              class="menu-item"
              *ngFor="let size of fontSizes"
              (mousedown)="preventBlur($event)"
              (click)="onFontSizeChange(size.label, size.value, $event)"
            >
              {{ size.label }}
            </button>
          </div>
        </div>

        <span class="toolbar-divider" aria-hidden="true"></span>

        <button
          type="button"
          class="tool-btn"
          title="Bold"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('bold')"
        >
          <strong>B</strong>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Italic"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('italic')"
        >
          <em>I</em>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Underline"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('underline')"
        >
          <span class="underline-icon">U</span>
        </button>

        <label
          class="tool-btn color-btn has-caret"
          title="Text color"
          (mousedown)="preventBlur($event)"
        >
          <span class="color-swatch">
            <span class="color-letter">A</span>
            <span class="color-bar" [style.background]="selectedTextColor"></span>
          </span>
          <span class="caret-icon"></span>
          <input
            type="color"
            [value]="selectedTextColor"
            (input)="onTextColor($event)"
          />
        </label>

        <span class="toolbar-divider" aria-hidden="true"></span>

        <div class="menu-wrap" (click)="keepMenuOpen($event)">
          <button
            type="button"
            class="tool-btn has-caret"
            title="Align"
            (mousedown)="preventBlur($event)"
            (click)="toggleMenu('align', $event)"
          >
            <svg class="tool-svg" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M3 5h18v2H3V5zm0 6h12v2H3v-2zm0 6h18v2H3v-2z"
              />
            </svg>
            <span class="caret-icon"></span>
          </button>
          <div class="menu-panel" *ngIf="openMenu === 'align'">
            <button
              type="button"
              class="menu-item"
              *ngFor="let align of alignments"
              (mousedown)="preventBlur($event)"
              (click)="onAlignChange(align.value, $event)"
            >
              <mat-icon>{{ align.icon }}</mat-icon>
              <span>{{ align.label }}</span>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="tool-btn"
          title="Numbered list"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('insertOrderedList')"
        >
          <mat-icon>format_list_numbered</mat-icon>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Bulleted list"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('insertUnorderedList')"
        >
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Decrease indent"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('outdent')"
        >
          <mat-icon>format_indent_decrease</mat-icon>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Increase indent"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('indent')"
        >
          <mat-icon>format_indent_increase</mat-icon>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Quote"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('formatBlock', 'blockquote')"
        >
          <mat-icon>format_quote</mat-icon>
        </button>

        <span class="toolbar-divider" aria-hidden="true"></span>

        <div class="menu-wrap" (click)="keepMenuOpen($event)">
          <button
            type="button"
            class="tool-btn"
            title="Line spacing"
            (mousedown)="preventBlur($event)"
            (click)="toggleMenu('spacing', $event)"
          >
            <svg class="tool-svg" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M6 7h2.5L7 4.5 5.5 7H8m0 10H5.5L7 19.5 8.5 17H6M4 11h16v2H4v-2zm4-6h12v2H8V5zm0 12h12v2H8v-2z"
              />
            </svg>
          </button>
          <div class="menu-panel" *ngIf="openMenu === 'spacing'">
            <button
              type="button"
              class="menu-item"
              *ngFor="let spacing of spacings"
              (mousedown)="preventBlur($event)"
              (click)="onSpacingChange(spacing.value, $event)"
            >
              {{ spacing.label }}
            </button>
          </div>
        </div>

        <span class="toolbar-divider" aria-hidden="true"></span>

        <button
          type="button"
          class="tool-btn"
          title="Clear formatting"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('removeFormat')"
        >
          <svg class="tool-svg" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M12.75 4h2.5L12 13.2 10.7 9.5H7.4L12.2 21H9.7L3.4 4h2.5l3.1 7.8L12.75 4z"
            />
            <path
              fill="currentColor"
              d="M2.9 3.4 21.1 21.6l-1.4 1.4L1.5 4.8 2.9 3.4z"
            />
          </svg>
        </button>
      </div>

      <div class="history-toolbar">
        <button
          type="button"
          class="tool-btn"
          title="Undo"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('undo')"
        >
          <svg class="tool-svg undo-svg" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 8H5V4"
            />
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M5 8a8 8 0 1 1-1.2 8.4"
            />
          </svg>
        </button>
        <button
          type="button"
          class="tool-btn"
          title="Redo"
          (mousedown)="preventBlur($event)"
          (click)="execCommand('redo')"
        >
          <svg class="tool-svg redo-svg" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 8h4V4"
            />
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 8a8 8 0 1 0 1.2 8.4"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="email-footer">
      <div class="footer-left">
        <div class="send-group menu-wrap" (click)="keepMenuOpen($event)">
          <button type="button" class="send-btn" (click)="sendEmail()">
            {{ 'EMAIL_SUPPORT_SEND' | translate }}
          </button>
          <button
            type="button"
            class="send-dropdown"
            aria-label="Send options"
            (click)="toggleMenu('send', $event)"
          >
            <span class="send-caret"></span>
          </button>
          <div class="menu-panel send-menu" *ngIf="openMenu === 'send'">
            <button type="button" class="menu-item" (click)="sendEmail()">
              Send
            </button>
            <button
              type="button"
              class="menu-item"
              (click)="enableConfidentialAndSend()"
            >
              Send as confidential
            </button>
          </div>
        </div>

        <button
          type="button"
          class="action-btn aa-btn"
          [class.active]="showFormatToolbar"
          title="Formatting options"
          (click)="toggleFormatToolbar()"
        >
          <span class="aa-icon">Aa</span>
        </button>

        <button
          type="button"
          class="action-btn"
          title="Help me write"
          (click)="helpMeWrite()"
        >
          <svg class="tool-svg sparkle-pen" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M14.06 9.02 15 9.96l-9.03 9.02H4.01v-1.97l10.05-10zM17.74 2.96c-.2 0-.39.08-.53.22l-1.58 1.58 2.62 2.62 1.58-1.58c.29-.29.29-.77 0-1.06l-1.56-1.56a.75.75 0 0 0-.53-.22z"
            />
            <path
              fill="currentColor"
              d="m18.2 8.1.9.9 1.1-1.1-.9-.9-1.1 1.1zm1.7-4.3.55 1.2 1.2.55-1.2.55-.55 1.2-.55-1.2-1.2-.55 1.2-.55.55-1.2zM14.3 4.4l.45.95.95.45-.95.45-.45.95-.45-.95-.95-.45.95-.45.45-.95z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="action-btn"
          title="Attach files"
          (click)="triggerAttach()"
        >
          <mat-icon>attach_file</mat-icon>
        </button>
        <button
          type="button"
          class="action-btn"
          title="Insert link"
          (click)="insertLink()"
        >
          <mat-icon>link</mat-icon>
        </button>

        <div class="menu-wrap" (click)="keepMenuOpen($event)">
          <button
            type="button"
            class="action-btn"
            title="Insert emoji"
            (click)="toggleMenu('emoji', $event)"
          >
            <mat-icon>sentiment_satisfied_alt</mat-icon>
          </button>
          <div class="menu-panel emoji-panel" *ngIf="openMenu === 'emoji'">
            <button
              type="button"
              class="emoji-item"
              *ngFor="let emoji of emojis"
              (mousedown)="preventBlur($event)"
              (click)="insertEmoji(emoji, $event)"
            >
              {{ emoji }}
            </button>
          </div>
        </div>

        <button
          type="button"
          class="action-btn"
          title="Insert from Drive"
          (click)="insertDriveLink()"
        >
          <mat-icon>cloud_upload</mat-icon>
        </button>
        <button
          type="button"
          class="action-btn"
          title="Insert photo"
          (click)="triggerImage()"
        >
          <mat-icon>image</mat-icon>
        </button>
        <button
          type="button"
          class="action-btn"
          [class.active]="isConfidential"
          title="Confidential mode"
          (click)="toggleConfidential()"
        >
          <mat-icon>lock</mat-icon>
        </button>
        <button
          type="button"
          class="action-btn"
          title="Insert signature"
          (click)="insertSignature()"
        >
          <mat-icon>create</mat-icon>
        </button>

        <div class="menu-wrap" (click)="keepMenuOpen($event)">
          <button
            type="button"
            class="action-btn"
            title="More options"
            (click)="toggleMenu('more', $event)"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <div class="menu-panel" *ngIf="openMenu === 'more'">
            <button type="button" class="menu-item" (click)="selectAllBody()">
              Select all
            </button>
            <button
              type="button"
              class="menu-item"
              (click)="toggleConfidential()"
            >
              {{ isConfidential ? 'Turn off confidential' : 'Confidential mode' }}
            </button>
            <button type="button" class="menu-item" (click)="closeDialog()">
              Discard draft
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="discard-btn"
        (click)="closeDialog()"
        [attr.aria-label]="'EMAIL_SUPPORT_DISCARD' | translate"
      >
        <svg class="tool-svg trash-svg" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M15 4V3H9v1H4v2h1v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6h1V4h-5zm2 15H7V6h10v13zM9 8h2v9H9V8zm4 0h2v9h-2V8z"
          />
        </svg>
      </button>
    </div>
  </div>

  <input
    #fileInput
    type="file"
    class="hidden-file-input"
    (change)="onFileSelected($event)"
  />
  <input
    #imageInput
    type="file"
    accept="image/*"
    class="hidden-file-input"
    (change)="onImageSelected($event)"
  />
</div>
